module.exports = __webpack_public_path__ + "static/img/jkfabj_icon.png";